import Cookies from 'js-cookie';
import _ from 'lodash';
import queryString from 'query-string';

function parsedQueryString() {
  return queryString.parse(window.location.search);
}

function utmParams() {
  return filterInvalidParams(
    _.pickBy(parsedQueryString(), (v, k) => _.startsWith(k, 'utm'))
  );
}

function otherParams() {
  const params = _.omitBy(parsedQueryString(), (v, k) =>
    _.startsWith(k, 'utm')
  );
  params['touch_type'] = _.isEmpty(utmParams()) ? 1 : 'immediate';

  return filterInvalidParams(params);
}

function filterInvalidParams(params) {
  return _.omitBy(params, (v, k) => k === '');
}

function utmCookieOrParams() {
  if (_.isEmpty(utmParams())) {
    return filterInvalidParams(Cookies.getJSON('maji_utm'));
  } else {
    return utmParams();
  }
}

function allParams() {
  return Object.assign({}, utmCookieOrParams(), otherParams());
}

export { allParams, otherParams, utmCookieOrParams, utmParams };
